import {nodeAddedMap} from './MutationHandler';
import {DotLottieWC} from '@lottiefiles/dotlottie-wc';

const tagName = 'dotlottie-wc';
export const DotLottieController = Object.freeze({
  tagName,
  selector: tagName,
  moduleUrl:
    'https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-wc@0.4.6/dist/dotlottie-wc.js',
  async ensureLoaded() {
    return import(/* webpackIgnore: true */ DotLottieController.moduleUrl);
  },
});

nodeAddedMap.set(DotLottieController.selector, (target) => {
  if (!isDotLottieWC(target)) {
    return;
  }

  if (!customElements.get(DotLottieController.tagName)) {
    DotLottieController.ensureLoaded();
  }
});

export function isDotLottieWC(target: HTMLElement): target is DotLottieWC {
  return target.matches(DotLottieController.selector);
}
